<template>
	<el-dialog title="操作信息提示" :visible.sync="dialogVisible" @close="close" :show-close="false"
		:close-on-click-modal="false" class="warn-dialog-warn" append-to-body width="660px">
		<yq-progress-bar :options="options" style="width: 100%;"></yq-progress-bar>
		<!-- <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="closeDialog" round class="large-warning">{{config.btnName}}</el-button>
        </span> -->
	</el-dialog>
</template>

<script>
export default {
	props: ['options'],
	created() {
		this.dialogVisible = this.options.showProgress
	},
	data() {
		return {
			dialogVisible: false
		}
	},
	methods: {
		close() {
			this.$emit('update:showProgress', false)
		}
	}
}

</script>

<style scoped>

</style>
